export default function initM13() {
    const $ = jQuery
    const postList = document.querySelector('#postList')
    if(postList){

        $(".filterSelect").on('change', function(){
            const year = $(this).val()
            const posttype = $(this).data("posttype");
            const listinglayout = $(this).data("listinglayout");
            const numposts = $(this).data("numposts");
            const postnotin = $(this).data("postnotin");
            const tags_in = $(this).data('tagsin');
            const searchTerm = $('.filterSearchfor').val() || '';
            const tag = $('.filterSelectTag').val() || '';

            $.get(`${theme_url}/blocks/loophandlers/m13-handler.php?numPosts=${numposts}&pageNumber=1&postType=${posttype}&listingLayout=${listinglayout}&post__not_in=${postnotin}&tags=${tags_in}&year=${year}&searchTerm=${searchTerm}&tag=${tag}`,function(data){
                if(data != "</section>"){
                    postList.innerHTML = data;
                } else {
                    postList.innerHTML = "<h3 style='color:#1b0b5e;'>No results found. Please try a different search.</h3>"+data;
                    // console.log("not found result..");
                }
                // postList.innerHTML = data
            })
        });

        $(".filterSearchfor").on('input', function(){
            // console.log("...")
            const searchTerm = $(this).val();
            // console.log("Search term:", searchTerm);
            const posttype = $(this).data("posttype");
            const listinglayout = $(this).data("listinglayout");
            const numposts = $(this).data("numposts");
            const postnotin = $(this).data("postnotin");
            const tags_in = $(this).data('tagsin');

            const year = $('.filterSelect').val() || '';
            const tag = $('.filterSelectTag').val() || '';

            // console.log(year)
            $.get(`${theme_url}/blocks/loophandlers/m13-handler.php?numPosts=${numposts}&pageNumber=1&postType=${posttype}&listingLayout=${listinglayout}&post__not_in=${postnotin}&tags=${tags_in}&year=${year}&searchTerm=${searchTerm}&tag=${tag}`,function(data){
                // console.log(data);
                if(data != "</section>"){
                    postList.innerHTML = data;
                } else {
                    postList.innerHTML = "<h3 style='color:#1b0b5e;'>No results found. Please try a different search.</h3>"+data;
                    console.log("not found result..");
                }
            })
        });

        $(".filterSelectTag").on('change', function(){
            const tag = $(this).val();
            // console.log(tag);

            // console.log("Search term:", searchTerm);
            const posttype = $(this).data("posttype");
            const listinglayout = $(this).data("listinglayout");
            const numposts = $(this).data("numposts");
            const postnotin = $(this).data("postnotin");
            const tags_in = $(this).data('tagsin');
            const year = $('.filterSelect').val() || '';
            const searchTerm = $('.filterSearchfor').val() || '';
            // console.log(theme_url); // http://localhost:8888/enero/wp-content/themes/enero-2023
            // console.log(`${theme_url}/blocks/loophandlers/m13-handler.php`)
            // console.log(`?numPosts=${numposts}&pageNumber=1&postType=${posttype}&listingLayout=${listinglayout}&post__not_in=${postnotin}&tags=${tags_in}&year=${year}&searchTerm=${searchTerm}&tag=${tag}`)
            
            $.get(`${theme_url}/blocks/loophandlers/m13-handler.php?numPosts=${numposts}&pageNumber=1&postType=${posttype}&listingLayout=${listinglayout}&post__not_in=${postnotin}&tags=${tags_in}&year=${year}&searchTerm=${searchTerm}&tag=${tag}`,function(data){
                // console.log(data);
                // postList.innerHTML = data;

                if(data != "</section>"){
                    postList.innerHTML = data;
                } else {
                    postList.innerHTML = "<h3 style='color:#1b0b5e;'>No results found. Please try a different search.</h3>"+data;
                    console.log("not found result..");
                }
            })
        });

        $(postList).on('click','.pagination ul li',function(){
            if($(this).hasClass('disabled') || $(this).hasClass('current')){
                // alert($(this).attr('class'))
                return
            }
            const paginationLiEl=$(this);
            const page = paginationLiEl.data("page")

            const paginationEl=paginationLiEl.parents('.pagination');
            const posttype = paginationEl.data("posttype");
            const listinglayout = paginationEl.data("listinglayout");
            const numposts = paginationEl.data("numposts");
            const postnotin = paginationEl.data("postnotin");
            // const tags_in = $(this).data('tagsin');
            // const searchTerm = $('.filterSearchfor').val();
            // const tag = $('.filterSelectTag').val();
            // const year = $('.filterSelect').val();


            $.get(`${theme_url}/blocks/loophandlers/m13-handler.php?numPosts=${numposts}&pageNumber=${page}&postType=${posttype}&listingLayout=${listinglayout}&post__not_in=${postnotin}${paginationEl.data("year") ? `&year=${paginationEl.data("year")}` : ""}`,function(data){
            
                // postList.innerHTML = data
                if(data != "</section>"){
                    postList.innerHTML = data;
                } else {
                    postList.innerHTML = "<h3 style='color:#1b0b5e;'>No results found. Please try a different search.</h3>"+data;
                    console.log("not found result..");
                }
            })
        });
    }
}